<template>
  <groups-list />
</template>

<script>
import GroupsList from '../../components/access/GroupsList';

export default {
  name: 'orgs-management',
  components: {
    GroupsList,
  },
};
</script>

<style scoped>
</style>